export const ATTACH_ACTION_SELECT_ACTION_FILE = 'attach_file'

export const ATTACH_ACTION_SELECT_DROPDOWN_WIDTH = 288

export const QA_NAME_ATTACH_ACTION_SELECT_DROPDOWN = 'AttachActionSelect'

export const ATTACH_ACTION_SELECT_FILE_FROM_STORAGE = 'attach_storage_file'
